export default __webpack_public_path__ + "static/media/IMG_0081.3ac139f3.jpg";